/* eslint-disable react/destructuring-assignment */
import React, { Component } from '@ali/odin/react';
import { Icon } from '@ali/odin/antd';
import styles from '../index.less';

class Home extends Component<{
  go: (index: 1 | 2 | 3) => void;
}, {
  index: number;
  playing: boolean;
  playFocus: boolean;
}>{
  constructor(props) {
    super(props);
    this.state = {
      index: 1,
      playing: false,
      playFocus: false,
    }
  }
  render() {
    const { playing, playFocus } = this.state;
    const { go } = this.props;
    return [
      <section key={2} className={styles.banner}>
        <div className={`${styles.container} ${styles.full}`}>
          <h1 key={0} className={styles.title}>优创作，酷互动</h1>
          <p key={1} className={styles.desc}>和创作者共建互动内容未来</p>
          {
            playing ?
              [
                <video
                  onMouseEnter={() => this.setState({playFocus: true})}
                  onMouseLeave={() => this.setState({playFocus: false})}
                  key={2}
                  src="//r1.ykimg.com/yk-fusion/release/interactive/%E4%BA%92%E5%8A%A8%E4%BA%A7%E5%93%81%E5%AE%A3%E4%BC%A0_0927.mp4"
                  autoPlay
                  controls
                  onEnded={() => {
                    this.setState({playing: false});
                  }}
                />,
                <a
                  key={3}
                  className={styles.playClose}
                  style={playFocus ? {opacity: 1} : {}}
                  onClick={() => this.setState({playing: false})}
                >
                  <Icon type="close-circle" /> 关闭视频
                </a>
              ] : 
              [
                <a key={2} className={styles.play} onClick={() => this.setState({playing: true})}></a>
              ]
          }
          <ul className={styles.keyPoints}>
            <li>
              <h4>丰富剧情</h4>
              <p>分支路线<br/>沉浸体验</p>
            </li>
            <li>
              <h4>强化叙事</h4>
              <p>代入角色<br/>触发情绪</p>
            </li>
            <li>
              <h4>促进收入</h4>
              <p>解锁剧情<br/>衍生付费</p>
            </li>
          </ul>
        </div>
      </section>,
      <section key={3} className={styles.service}>
        <div className={styles.container}>
          <h1>为创作者保驾护航</h1>
          <p className={styles.desc}>优酷提供互动内容生产的一站式支持</p>
          <ul>
            <li>
              <h3>零基础创作</h3>
              <p>· 故事线构建<br/>· 简单配置<br/>· 支线效果预览</p>
            </li>
            <li>
              <h3>新玩法实现</h3>
              <p>· 玩法深度定制<br/>· 开发流程接入<br/>· 贴身服务支持</p>
            </li>
            <li>
              <h3>供应商收益</h3>
              <p>· 10亿基金支持<br/>· 极速回款<br/>· 收益方式多元</p>
            </li>
          </ul>
        </div>
      </section>,
      <section key={4} className={styles.ark}>
        <div className={styles.container}>
          <h1>互动内容是娱乐的未来</h1>
          <ul>
            <li>
              <p>互动视频有着其他视频所不具备的沉浸式体验，特别是分支剧情结构解决了不同偏好人对故事设定的不同需求，令观众有了更强的控制力。</p>
            </li>
            <li>
              <p>5G+AI时代，可以预见，高速网络与人工智能的交叉发展将激发创作者探索更多互动内容生产的可能性，带来更多“好看”与“好玩”兼具的作品，让用户获得真三维的交互参与感。</p>
            </li>
            <li>
              <p>互动内容直接从底层改变了传统线性故事内容的架构方式，内容不再是创作者的一言堂，通过在关键节点选择达到观众引导剧情的目的，也令观众大呼过瘾。</p>
            </li>
          </ul>
        </div>
      </section>,
      <section key={5} className={styles.cooperation}>
        <div className={styles.container}>
          <h1>申请互动内容合作</h1>
          <ul>
            <li>
              <h3>内容要求</h3>
              <hr/>
              <p>符合国家相关政策法律法规及审查标准，符合优酷内容价值观，版权归属清晰。</p>
            </li>
            <li>
              <h3>介质要求</h3>
              <hr/>
              <p>详细项目策划案（含主创信息）、故事逻辑线、故事大纲、人物小传、公司介绍等。</p>
            </li>
            <li>
              <h3>提交方式</h3>
              <hr/>
              <p>邮件：youku-hudong@service.alibaba.com<br/>标题请注明：合作申请_《片名》_公司名称。</p>
            </li>
          </ul>
          <div className={styles.btnGroup}>
            <a className={styles.make} onClick={() => go(2)}>查看创作标准</a>
            <a className={styles.dev} onClick={() => go(3)}>查看技术标准</a>
          </div>
        </div>
      </section>
    ]
  }
}

export default Home;
